export default {
    ILUMA_I2_CHARGER: 'ILUMA_I2_CHARGER',
    ILUMA_I2_HOLDER: 'ILUMA_I2_HOLDER',
    ILUMA_I5_CHARGER: 'ILUMA_I5_CHARGER',
    ILUMA_I5_HOLDER: 'ILUMA_I5_HOLDER',
    UNKNOWN: 'UNKNOWN',
};
